import { INVALID_1000, isDataValid, MAPSTYLES } from "../shared";
import CalElev from "./CalElev";
import ColorMapHelper from "./ColorMapHelper";

function calxy(dia, theta, add180 = false) {
  const _dia = dia || 4;
  return {
    x: _dia * Math.cos(((theta + (add180 ? 180 : 0)) * Math.PI) / 180),
    y: _dia * Math.sin(((theta + (add180 ? 180 : 0)) * Math.PI) / 180)
  };
}
function calElevParams(casePath) {
  let casepath = casePath;
  let elevParams = CalElev.getDefaultParams();
  let data = null;
  if (CalElev.cal(elevParams, casepath)) {
    data = elevParams.data;
  }
  CalElev.free(elevParams);
  return data;
}
function getElevMapValue(p1, p2, p3, p4, casePath) {
  let elevData = calElevParams(casePath);
  if (!elevData) {
    return INVALID_1000;
  }
  let ptr = ColorMapHelper.initColorMap();
  if (!ptr) {
    return INVALID_1000;
  }
  if (
    ColorMapHelper.updateMapProp(ptr, MAPSTYLES.ElevationF, casePath) &&
    ColorMapHelper.UpdateMapData(ptr, elevData)
  ) {
    let arr = [p1, p2, p3, p4];
    let result = true;
    let analog = false;
    arr.forEach((item) => {
      let obj = ColorMapHelper.getPixelIndexAndValue(ptr, item.x, item.y, true);
      if (obj.analog === 1) {
        analog = true;
      }
      if (obj.result === 0) {
        item.value = obj.value;
        if (item.value === INVALID_1000) {
          result = false;
        }
      } else {
        result = false;
        item.value = INVALID_1000;
      }
    });
    if (result) {
      ColorMapHelper.freeColorMap(ptr);
      return {
        val: Math.abs((arr[0].value + arr[1].value - arr[2].value - arr[3].value) / 2),
        analog
      };
    }
  }
  ColorMapHelper.freeColorMap(ptr);
  return { val: INVALID_1000 };
}
export const calcElevDiff = (casePath, axisF, axisS) => {
  const dia = 4;

  if (isDataValid(axisF) && isDataValid(axisS)) {
    let p1 = calxy(dia, axisF);
    let p2 = calxy(dia, axisF, true);
    let p3 = calxy(dia, axisS);
    let p4 = calxy(dia, axisS, true);
    let diffObj = getElevMapValue(p1, p2, p3, p4, casePath);
    if (diffObj.val !== INVALID_1000) {
      return diffObj;
    } else {
      return { val: INVALID_1000 };
    }
  } else {
    return { val: INVALID_1000 };
  }
};



// WEBPACK FOOTER //
// ./src/topography/js/calc4mmElevDiff.js